<script>
export default {
  name: "NursingNotesModal",

  data() {

      return {
          active: 0,
          activeClass: `bg-gray-100 border-l-2 border-r-2 border-t-2 
            border-gray-500 rounded-t-md z-10 -mb-1`,
          inActiveClass: `bg-gray-300 border-l border-r border-t`,
      };
  },

  props: {
      showModal: {
          type: Boolean,
          required: true,
          default: false,
      },
      patient: {
          type: Object,
          required: true,
          default: () => ({}),
      },
  },

  components: {
    "nursing-care-plan-tab": () => import("./tabs/NursingCarePlanTab.vue"),
    "cardex-tab": () => import("./tabs/CardexTab.vue"),
    "vitals-monitor-tab": () => import("./tabs/VitalsMonitorTab.vue"),
    "fluid-balance-chart-tab": () => import("./tabs/FluidBalanceTab.vue"),
  },
};
</script>
<template>
  <tail-modal :show="showModal" dimension="w-11/12">
    <template v-slot:title>
      <h5 class="font-medium text-sm">Nursing Notes</h5>
    </template>
    <template v-slot:modal-body>
      <div class="w-full flex flex-wrap items-center">
          <ul
            class="w-full flex border-b-2 border-gray-500"
          >
            <li class="-mb-px mr-1">
              <a
                @click.prevent="active = 0"
                href="javascript:void()"
                class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 font-bold 
                            whitespace-no-wrap"
                :class="active == 0 ? activeClass : inActiveClass"
              >
                <i class="fa fa-notes-medical"></i> Nursing Care Plan</a
              >
            </li>
            <li class="-mb-px mr-1">
              <a
                @click.prevent="active = 1"
                href="javascript:void()"
                class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 font-bold 
                               whitespace-no-wrap"
                :class="active == 1 ? activeClass : inActiveClass"
              >
                <i class="fa fa-briefcase-medical"></i> Cardex</a
              >
            </li>
            <li class="-mb-px mr-1">
              <a
                @click.prevent="active = 2"
                href="javascript:void()"
                class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 font-bold 
                                whitespace-no-wrap"
                :class="active == 2 ? activeClass : inActiveClass"
              >
                <i class="fa fa-thermometer"></i> Vitals Monitor</a
              >
            </li>
            <li class="-mb-px mr-1">
              <a
                @click.prevent="active = 3"
                href="javascript:void()"
                class="btn-sm text-sm text-gray-900 rounded-t-md inline-block px-4 font-bold 
                                whitespace-no-wrap"
                :class="active == 3 ? activeClass : inActiveClass"
              >
                <i class="fa fa-stethoscope"></i> Fluid Balance Chart</a
              >
            </li>
        </ul>
        <div
          class="w-full"
          v-if="active === 0"
        >
          <nursing-care-plan-tab />
        </div>
        <div
          class="w-full"
          v-if="active === 1"
        >
          <cardex-tab />
        </div>
        <div
          class="w-full"
          v-if="active === 2"
        >
          <vitals-monitor-tab />
        </div>
        <div
          class="w-full"
          v-if="active === 3"
        >
          <fluid-balance-chart-tab />
        </div>
      </div>
    </template>
    <template v-slot:modal-footer>
      <button
        class="btn-danger btn-sm text-xs rounded"
        @click.prevent="$emit(`closeModal`)"
      >
        Close
      </button>
    </template>
  </tail-modal>
</template>
